import { WidgetsWarehouseMain } from '@/widgets/warehouse';

export const PagesWarehouseMain = () => <WidgetsWarehouseMain />;
